import config from '@plone/volto/registry';
import { useSelector } from 'react-redux';

export function useIsTranslating() {
  return useSelector(
    (state) =>
      !state.googleTranslate.loading &&
      state.googleTranslate.loaded &&
      !!state.googleTranslate.language,
  );
}

export function translateIsEnabled() {
  const isEnabled = config.settings['volto-google-translate'].enabled;
  if (isEnabled !== undefined) {
    return isEnabled;
  }
  return true;
}

export function useIsReadyToTranslate() {
  return useSelector(
    (state) =>
      state.loadProtector.requestCount === 0 &&
      state.loadProtector.isCounting === false &&
      !state.googleTranslate.loading &&
      state.googleTranslate.loaded,
  );
}
